import { axiosClient } from "./axiosClient"

export const EXCHANGE_PATH = '/api/v1/exchange'

export const fetchExchange = (body) => {
    return axiosClient.get(EXCHANGE_PATH, body)
}
